<template>
  <div class="flex flex-col items-center justify-center h-full py-8">
    <label class="block text-xl font-medium text-gray-700 mb-8">
      How would you rate your experience?
    </label>
    <div class="flex flex-col items-center gap-4">
      <StarSelector
        v-model="rating"
        class="transform scale-150"
        color="primary"
      />
      <span
        v-if="rating"
        class="text-2xl font-medium text-gray-700 mt-4"
      >
        {{ rating }}/5
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import StarSelector from '~/components/common/StarSelector.vue'

const props = defineProps<{
  modelValue: number
}>()
const emit = defineEmits<{
  'update:modelValue': [value: number]
}>()
const rating = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value)
})
</script>
